import _ from 'lodash';
import React, { Component } from "react";
import { Button, ButtonToolbar, DropdownButton, MenuItem, Modal } from 'react-bootstrap';
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import CSVWrapper from '../Shared/CSVWrapper';
import Pagination from "../Shared/pagination";
import DealsService from '../utils/DealsService';
import DealsTable from "./DealsTable";


class DealsListView extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      filter: { view: "list", assigned: "" },
      items: [], initialItems: [],
      textFilter: '',
      flags: [],
      selectedItems: [],
      showMessageModal: false,
      modalMessageAudience: 'primary',
      smsGroupMessages: props.smsGroupMessages,
      emailGroupMessages: props.emailGroupMessages,
      currentPage: 1,
      per: 100
    };
    this.debouncedFetchItems = _.debounce(() => this.fetchItems(), 300)

  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, this.fetchItems)
  }

  onPageChange = (currentPage) => {
    this.setState({ currentPage: currentPage }, () => this.fetchItems());
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view, smsGroupMessages: this.props.smsGroupMessages, emailGroupMessages: this.props.emailGroupMessages, currentPage: 1 }, this.fetchItems)
    }
  }

  fetchItems() {
    DealsService.index({ view: this.state.view, text_filter: this.state.textFilter, page: this.state.currentPage, per: this.state.per }).then(response => {
      this.setState({ loadingInProgress: false, items: response.results, totalPages: Math.ceil(response.total_count / this.state.per) })
    })
  }

  handleFlagChange = (flags) => {
    this.setState({ flags: flags })
  }

  itemSelectAllChanged = (selected) => {
    var items = JSON.parse(JSON.stringify(this.state.items)).map((item) => {
      item.isSelected = selected
      return item
    })
    this.setState({ items: items })
  }

  itemSelectStateChanged = (id, selected) => {
    var items = JSON.parse(JSON.stringify(this.state.items)).map((item) => {
      if (item.id === id) item.isSelected = selected
      return item
    })

    this.setState({ items: items })
  }

  selectedItems = () => {
    return this.state.items.filter((item) => item.isSelected)
  }

  groupActionsEnabled = () => {
    return this.selectedItems().length > 0
  }

  closeMessageModal = () => {
    this.setState({ showMessageModal: false, modalMessageType: null, modalMessageIndex: null, modalMessageItem: null });
  }

  showMessageModal = (type, index, item) => {
    this.setState({ showMessageModal: true, modalMessageType: type, modalMessageIndex: index, modalMessageItem: item });
  }

  sendMessage = (testMode) => {
    this.setState({ sendingMessage: true })
    const params = { deal_ids: this.selectedItems().map((item) => item.id), message_type: this.state.modalMessageType, message_item: this.state.modalMessageItem, test_mode: testMode, audience: this.state.modalMessageAudience }
    DealsService.sendGroupMessage(params)
      .then((response) => {
        Alert.success('Sent message OK')
        if (!testMode) this.closeMessageModal()
        this.setState({ sendingMessage: false })
      })
      .catch((response) => {
        Alert.error(`<h1>Error sending message</h1><p>${response.data.message}</p>`, { html: true, timeout: 10000 })
        this.setState({ sendingMessage: false })
      })
  }

  handleTextFilterChange = (event) => {
    let value = event.target.value;
    this.setState({ textFilter: value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }, this.debouncedFetchItems)
  }

  render() {
    const authStore = this.context

    const headers = [
      { label: 'ID', key: 'id' },
      { label: 'First Name', key: 'first_name' },
      { label: 'Student First Name', key: 'student_first_name' },
      { label: 'Email', key: 'email' },
      { label: 'Mobile', key: 'mobile' },
    ];

    const { loadingInProgress } = this.state;
    const profile = authStore.profile
    return (
      <LoadingIndicator loadingInProgress={loadingInProgress}>

        <div className='row'>
          <div className="col-sm-3">
            <div style={{ margin: '0 0 10px 0' }}>
              <input type="text" placeholder="Search" className='form-control input-sm' value={this.state.textFilter} onChange={this.handleTextFilterChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <ButtonToolbar>
              <DropdownButton
                bsStyle='info'
                bsSize='xsmall'
                title='Email'
                key='1'
                id='dropdown-group-actions'
                disabled={!this.groupActionsEnabled()}
              >
                {this.state.emailGroupMessages && this.state.emailGroupMessages.map((item, index) =>
                  <MenuItem key={index} eventKey={index} id={item.id} onClick={() => this.showMessageModal('email', index, item)}>{item.description}</MenuItem>
                )}
              </DropdownButton>
              <DropdownButton
                bsStyle='info'
                bsSize='xsmall'
                title='SMS'
                key='2'
                id='dropdown-group-actions'
                disabled={!this.groupActionsEnabled()}
              >
                {this.state.smsGroupMessages && this.state.smsGroupMessages.map((item, index) =>
                  <MenuItem key={index} eventKey={index} id={item.template_text} onClick={() => this.showMessageModal('sms', index, item)}>{item.description}</MenuItem>
                )}
              </DropdownButton>
            </ButtonToolbar>
          </div>
          <div className="col-sm-3">
            {this.state.totalPages >= 2 ? (<div className='pull-right'>
              <Pagination
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onChange={this.onPageChange}
              />
            </div>) : <span></span>}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div>
              {this.state.items.length === 0
                ? <h5>No matching deals</h5>
                : <DealsTable
                  items={this.state.items}
                  itemSelectStateChanged={this.itemSelectStateChanged}
                  itemSelectAllChanged={this.itemSelectAllChanged}
                  view={this.props.view}
                />
              }

            </div>
          </div>
        </div>


        {this.state.items && this.state.items.length > 0 && <div style={{ marginTop: '30px' }}>
          <CSVWrapper data={this.state.items} headers={headers} asyncOnClick={false}>Download page as CSV</CSVWrapper>
        </div>}


        <Modal show={this.state.showMessageModal} onHide={this.closeMessageModal}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalMessageType} : {this.state.showMessageModal && this.state.modalMessageItem.description}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.sendingMessage
              ? <p>Sending message</p>
              : <div>
                <p>
                  This will send a message to {this.selectedItems().length} deals
            </p>

                <div className='form-group'>
                  <label>Send To</label>
                  <select className="form-control input-sm" value={this.state.modalMessageAudience} onChange={(e) => this.setState({ modalMessageAudience: e.target.value })}>
                    <option value='primary'>Primary Contact</option>
                    <option value='all'>All Contacts</option>
                    <option value='parents'>All Parent Contacts</option>
                    <option value='students'>All Student Contacts</option>
                  </select>
                </div>


                {this.state.modalMessageType === 'email' && <p>Sending a test will send an email to {profile.email}</p>}
                {this.state.modalMessageType === 'sms' && (profile.phone ? <p> Sending a test will send an SMS to {profile.phone} </p> : <p>You have no phone number setup to send a test to</p>)}
              </div>}
          </Modal.Body>
          <Modal.Footer>
            {!this.state.sendingMessage && <div>
              <Button onClick={this.closeMessageModal} bsSize='small'>Close</Button>
              <Button bsStyle='default' bsSize='small' onClick={() => this.sendMessage(true)}>Send test to yourself</Button>
              <Button bsStyle='primary' bsSize='small' onClick={() => this.sendMessage(false)}>Send to {this.selectedItems().length} deals</Button>
            </div>}
          </Modal.Footer>
        </Modal>
      </LoadingIndicator>
    );
  }
}
export default DealsListView
